// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.library-citation-popover-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: transparent;
}

.library-citation-popover {
  position: fixed;
  width: 420px;
  max-height: 320px;
  background: var(--theme-bg-primary);
  border-radius: var(--radius-md);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 10000;
}
.library-citation-popover__search-container {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-right: 4px;
  border-bottom: 1px solid var(--theme-border-soft);
}
.library-citation-popover input.library-citation-popover__search {
  flex: 1 1;
  padding: 10px 12px;
  border: none;
  background: transparent;
  color: var(--theme-text-primary);
  font-size: 13px;
}
.library-citation-popover input.library-citation-popover__search:focus {
  outline: none;
}
.library-citation-popover input.library-citation-popover__search::placeholder {
  color: var(--theme-text-tertiary);
}
.library-citation-popover__open-library-btn {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--theme-text-secondary);
  cursor: pointer;
  transition: all 0.15s ease;
}
.library-citation-popover__open-library-btn:hover {
  background: var(--theme-hover-bg);
  color: var(--theme-text-primary);
}
.library-citation-popover__open-library-btn:active {
  transform: scale(0.95);
}
.library-citation-popover__list {
  flex: 1 1;
  overflow: auto;
  padding: 4px;
}
.library-citation-popover__empty {
  text-align: center;
  padding: 24px 12px;
  color: var(--theme-text-tertiary);
  font-size: 13px;
}
.library-citation-popover__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: background 0.1s ease;
}
.library-citation-popover__item:hover, .library-citation-popover__item--highlighted {
  background: var(--theme-hover-bg);
}
.library-citation-popover__item--selected {
  background: var(--theme-primary-soft);
}
.library-citation-popover__item-check {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: var(--theme-primary);
}
.library-citation-popover__item-content {
  flex: 1 1;
  min-width: 0;
}
.library-citation-popover__item-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--theme-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.4;
  max-height: 2.8em;
}
.library-citation-popover__item-meta {
  font-size: 11px;
  color: var(--theme-text-tertiary);
  line-height: 1.3;
  margin-top: 1px;
}
.library-citation-popover__item-key {
  flex-shrink: 0;
  font-size: 10px;
  font-family: "Menlo", "Monaco", "Courier New", monospace;
  color: var(--theme-text-tertiary);
  background: var(--theme-bg-secondary);
  padding: 2px 4px;
  border-radius: 3px;
}
.library-citation-popover__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-top: 1px solid var(--theme-border-soft);
  background: var(--theme-bg-secondary);
  font-size: 12px;
}
.library-citation-popover__footer span {
  color: var(--theme-text-secondary);
}
.library-citation-popover__footer button {
  padding: 4px 12px;
  border: none;
  border-radius: var(--radius-sm);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  background: var(--theme-primary);
  color: var(--theme-primary-contrast);
  transition: background 0.1s ease;
}
.library-citation-popover__footer button:hover {
  background: var(--theme-primary-hover);
}

span[data-citation-id] {
  background: var(--theme-primary-soft);
  border-radius: var(--radius-sm);
  padding: 1px 4px;
  cursor: pointer;
  transition: all 0.15s ease;
}
span[data-citation-id]:hover {
  background: var(--theme-primary);
  color: var(--theme-primary-contrast);
}

.library-citation {
  background-color: rgba(59, 130, 246, 0.15);
  padding: 2px 4px;
  border-radius: 3px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  -webkit-user-select: text;
          user-select: text;
}
.library-citation:hover {
  background-color: rgba(59, 130, 246, 0.25);
}
.library-citation::selection {
  background-color: rgba(59, 130, 246, 0.4);
}

.citation-tooltip {
  background: var(--theme-bg-primary);
  border: 1px solid var(--theme-border-primary);
  border-radius: var(--radius-md);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 12px;
  max-width: 400px;
}
.citation-tooltip__ref:not(:last-child) {
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--theme-border-soft);
}
.citation-tooltip__title {
  font-size: 13px;
  font-weight: 600;
  color: var(--theme-text-primary);
  margin-bottom: 4px;
  line-height: 1.4;
}
.citation-tooltip__authors {
  font-size: 12px;
  color: var(--theme-text-secondary);
  margin-bottom: 2px;
}
.citation-tooltip__journal {
  font-size: 11px;
  color: var(--theme-text-secondary);
  font-style: italic;
  margin-bottom: 2px;
}
.citation-tooltip__year {
  font-size: 11px;
  color: var(--theme-text-tertiary);
  margin-bottom: 4px;
}
.citation-tooltip__hint {
  font-size: 11px;
  color: var(--theme-primary);
  font-style: italic;
  margin-top: 6px;
}`, "",{"version":3,"sources":["webpack://./src/apps/LibraryApp/integration/LibraryDocsPlugin.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,mCAAA;EACA,+BAAA;EACA,yEAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,iDAAA;AACJ;AAEE;EACE,SAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,gCAAA;EACA,eAAA;AAAJ;AAEI;EACE,aAAA;AAAN;AAGI;EACE,iCAAA;AADN;AAKE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,+BAAA;EACA,uBAAA;EACA,kCAAA;EACA,eAAA;EACA,0BAAA;AAHJ;AAKI;EACE,iCAAA;EACA,gCAAA;AAHN;AAMI;EACE,sBAAA;AAJN;AAQE;EACE,SAAA;EACA,cAAA;EACA,YAAA;AANJ;AASE;EACE,kBAAA;EACA,kBAAA;EACA,iCAAA;EACA,eAAA;AAPJ;AAUE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,gCAAA;AARJ;AAUI;EAEE,iCAAA;AATN;AAYI;EACE,qCAAA;AAVN;AAcE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,2BAAA;AAZJ;AAeE;EACE,SAAA;EACA,YAAA;AAbJ;AAgBE;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;AAdJ;AAiBE;EACE,eAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;AAfJ;AAkBE;EACE,cAAA;EACA,eAAA;EACA,wDAAA;EACA,iCAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;AAhBJ;AAmBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,8CAAA;EACA,qCAAA;EACA,eAAA;AAjBJ;AAmBI;EACE,kCAAA;AAjBN;AAoBI;EACE,iBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,oCAAA;EACA,gCAAA;AAlBN;AAoBM;EACE,sCAAA;AAlBR;;AAyBA;EACE,qCAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAtBF;AAwBE;EACE,gCAAA;EACA,oCAAA;AAtBJ;;AA2BA;EACE,0CAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,uCAAA;EACA,yBAAA;UAAA,iBAAA;AAxBF;AA0BE;EACE,0CAAA;AAxBJ;AA2BE;EACE,yCAAA;AAzBJ;;AA8BA;EACE,mCAAA;EACA,6CAAA;EACA,+BAAA;EACA,0CAAA;EACA,aAAA;EACA,gBAAA;AA3BF;AA8BI;EACE,mBAAA;EACA,oBAAA;EACA,iDAAA;AA5BN;AAgCE;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;AA9BJ;AAiCE;EACE,eAAA;EACA,kCAAA;EACA,kBAAA;AA/BJ;AAkCE;EACE,eAAA;EACA,kCAAA;EACA,kBAAA;EACA,kBAAA;AAhCJ;AAmCE;EACE,eAAA;EACA,iCAAA;EACA,kBAAA;AAjCJ;AAoCE;EACE,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;AAlCJ","sourcesContent":[".library-citation-popover-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  background: transparent;\n}\n\n.library-citation-popover {\n  position: fixed;\n  width: 420px;\n  max-height: 320px;\n  background: var(--theme-bg-primary);\n  border-radius: var(--radius-md);\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  z-index: 10000;\n  \n  &__search-container {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding-right: 4px;\n    border-bottom: 1px solid var(--theme-border-soft);\n  }\n  \n  input.library-citation-popover__search {\n    flex: 1;\n    padding: 10px 12px;\n    border: none;\n    background: transparent;\n    color: var(--theme-text-primary);\n    font-size: 13px;\n    \n    &:focus {\n      outline: none;\n    }\n    \n    &::placeholder {\n      color: var(--theme-text-tertiary);\n    }\n  }\n  \n  &__open-library-btn {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border: none;\n    border-radius: var(--radius-sm);\n    background: transparent;\n    color: var(--theme-text-secondary);\n    cursor: pointer;\n    transition: all 0.15s ease;\n    \n    &:hover {\n      background: var(--theme-hover-bg);\n      color: var(--theme-text-primary);\n    }\n    \n    &:active {\n      transform: scale(0.95);\n    }\n  }\n  \n  &__list {\n    flex: 1;\n    overflow: auto;\n    padding: 4px;\n  }\n  \n  &__empty {\n    text-align: center;\n    padding: 24px 12px;\n    color: var(--theme-text-tertiary);\n    font-size: 13px;\n  }\n  \n  &__item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 8px;\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    transition: background 0.1s ease;\n    \n    &:hover,\n    &--highlighted {\n      background: var(--theme-hover-bg);\n    }\n    \n    &--selected {\n      background: var(--theme-primary-soft);\n    }\n  }\n  \n  &__item-check {\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    color: var(--theme-primary);\n  }\n  \n  &__item-content {\n    flex: 1;\n    min-width: 0;\n  }\n  \n  &__item-title {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--theme-text-primary);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    -webkit-box-orient: vertical;\n    line-height: 1.4;\n    max-height: calc(1.4em * 2); // 2 lines max\n  }\n  \n  &__item-meta {\n    font-size: 11px;\n    color: var(--theme-text-tertiary);\n    line-height: 1.3;\n    margin-top: 1px;\n  }\n  \n  &__item-key {\n    flex-shrink: 0;\n    font-size: 10px;\n    font-family: 'Menlo', 'Monaco', 'Courier New', monospace;\n    color: var(--theme-text-tertiary);\n    background: var(--theme-bg-secondary);\n    padding: 2px 4px;\n    border-radius: 3px;\n  }\n  \n  &__footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 12px;\n    border-top: 1px solid var(--theme-border-soft);\n    background: var(--theme-bg-secondary);\n    font-size: 12px;\n    \n    span {\n      color: var(--theme-text-secondary);\n    }\n    \n    button {\n      padding: 4px 12px;\n      border: none;\n      border-radius: var(--radius-sm);\n      font-size: 12px;\n      font-weight: 500;\n      cursor: pointer;\n      background: var(--theme-primary);\n      color: var(--theme-primary-contrast);\n      transition: background 0.1s ease;\n      \n      &:hover {\n        background: var(--theme-primary-hover);\n      }\n    }\n  }\n}\n\n// Citation rendering styles\nspan[data-citation-id] {\n  background: var(--theme-primary-soft);\n  border-radius: var(--radius-sm);\n  padding: 1px 4px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  \n  &:hover {\n    background: var(--theme-primary);\n    color: var(--theme-primary-contrast);\n  }\n}\n\n// Citation mark in document\n.library-citation {\n  background-color: rgba(59, 130, 246, 0.15);\n  padding: 2px 4px;\n  border-radius: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n  user-select: text;\n  \n  &:hover {\n    background-color: rgba(59, 130, 246, 0.25);\n  }\n  \n  &::selection {\n    background-color: rgba(59, 130, 246, 0.4);\n  }\n}\n\n// Citation tooltip\n.citation-tooltip {\n  background: var(--theme-bg-primary);\n  border: 1px solid var(--theme-border-primary);\n  border-radius: var(--radius-md);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  padding: 12px;\n  max-width: 400px;\n  \n  &__ref {\n    &:not(:last-child) {\n      margin-bottom: 12px;\n      padding-bottom: 12px;\n      border-bottom: 1px solid var(--theme-border-soft);\n    }\n  }\n  \n  &__title {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--theme-text-primary);\n    margin-bottom: 4px;\n    line-height: 1.4;\n  }\n  \n  &__authors {\n    font-size: 12px;\n    color: var(--theme-text-secondary);\n    margin-bottom: 2px;\n  }\n  \n  &__journal {\n    font-size: 11px;\n    color: var(--theme-text-secondary);\n    font-style: italic;\n    margin-bottom: 2px;\n  }\n  \n  &__year {\n    font-size: 11px;\n    color: var(--theme-text-tertiary);\n    margin-bottom: 4px;\n  }\n  \n  &__hint {\n    font-size: 11px;\n    color: var(--theme-primary);\n    font-style: italic;\n    margin-top: 6px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
